import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ITrainer } from 'models/trainer';
import { IVendor } from 'models/vendor';
import { useTranslation } from 'react-i18next';
import { ICompetency } from 'models/competency';
import { IAcquireSources, IEmployeeCompetency } from 'models/employeeCompetencies';


interface Props {
  open: boolean;
  loading: boolean;
  Competencies: ICompetency[];
  AcquireSources: IAcquireSources[];
  selectedEmployeeCompetency: IEmployeeCompetency;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditEmployeeCompetency: React.FC<Props> = ({ open, loading, Competencies, AcquireSources, selectedEmployeeCompetency, onClose, onSubmit, onChanges }) => {
  const { i18n } = useTranslation();
  const competencyOptions = Competencies.map((competency) => {
    return { value: competency.id, label: competency.name };
  });

  const acquireSourceOptions = AcquireSources.map((acquireSource) => {
    return { value: acquireSource.id.toString(), label: i18n.language === "en" ? acquireSource.name : acquireSource.nameAr };
  });

  const { t } = useTranslation()

  let basicFields: IFormField[] = [
    {
      name: 'competencyId',
      label: t('T_competency'),
      type: InputTypes.SELECT,
      placeholder: t('T_select_competency'),
      internalLabel: true,
      options: competencyOptions,
      defaultValue: competencyOptions.find(x => x.value == selectedEmployeeCompetency.competencyId),
      required: true
    },
    {
      name: 'acquireSource',
      label: t('T_acquire_source'),
      type: InputTypes.SELECT,
      placeholder: t('T_acquire_source'),
      internalLabel: true,
      options: acquireSourceOptions,
      defaultValue: acquireSourceOptions.find(x => x.value == selectedEmployeeCompetency.acquireSource.toString()),
      required: true
    },
    {
      name: 'verified',
      label: t('T_verified'),
      type: InputTypes.SWITCH,
      internalLabel: true,
      defaultValue: selectedEmployeeCompetency.verified,
      required: true
    },
  ];


  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_competency')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_save')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditEmployeeCompetency;
